/**
 * AOV Analytics — Central Listener
 *
 * Listens for `aov:lever` custom events on `document` and forwards
 * the payload to the analytics layer (dataLayer / Klaviyo / custom endpoint).
 *
 * Event detail shape:
 *   { lever: string, surface: string, action: string, product_id: number|null, value_cents: number|null }
 *
 * Actions: impression, accept, dismiss
 */
(function () {
  'use strict';

  document.addEventListener('aov:lever', function (e) {
    var detail = e.detail;
    if (!detail || !detail.lever || !detail.action) return;

    var payload = {
      event: 'aov_lever_' + detail.action,
      aov_lever: detail.lever,
      aov_surface: detail.surface || '',
      aov_action: detail.action,
      aov_product_id: detail.product_id || null,
      aov_value_cents: detail.value_cents || null
    };

    // Forward to dataLayer (GTM / GA4)
    if (window.dataLayer) {
      window.dataLayer.push(payload);
    }

    // Forward to Klaviyo if available
    if (window.klaviyo && typeof window.klaviyo.push === 'function') {
      window.klaviyo.push(['track', 'AOV Lever ' + detail.action, {
        lever: detail.lever,
        surface: detail.surface,
        product_id: detail.product_id,
        value_cents: detail.value_cents
      }]);
    }
  });
})();
